/**
 * Coordonnées par défaut d'une entreprise : la forme, jamais une identité.
 *
 * Ces valeurs servaient de repli partout dans l'interface — `soc?.iban ||
 * SOC.iban`. Elles portaient les coordonnées réelles d'une entreprise, si bien
 * qu'une autre société dont un champ était vide voyait apparaître le nom,
 * l'adresse et surtout l'IBAN de celle-là sur ses propres documents. Une facture
 * envoyée dans ces conditions fait virer l'argent sur le mauvais compte.
 *
 * Les champs sont donc vides. Un document au nom manquant se remarque et se
 * corrige ; un document au mauvais IBAN ne se remarque pas.
 */
export const SOC = {
  // Un intitulé de remplacement, qui ne prétend être personne.
  nom: 'Mon entreprise',
  adr: '',
  npa: '',
  tel: '',
  email: '',
  rc: '',
  tva: '',
  iban: '',
  forme: '',
  logo: '',
  reseaux: { site: '', instagram: '', facebook: '' },
  reseauxShow: { site: false, instagram: false, facebook: false },
  // Délai d'acompte usuel, qui ne désigne personne.
  acompteDelai: 10,
};

export const TPL_DEVIS_DEF =
  'Bonjour {client},\n\nVeuillez trouver votre devis {num} via le lien : {lien}\n\nMeilleures salutations,\n{societe}';

export const TPL_FACTURE_DEF =
  'Bonjour {client},\n\nVeuillez trouver votre facture {num} via le lien : {lien}\n\nMontant : {montant}\n\nMerci de votre confiance,\n{societe}';

export const BUILD = '2026.09.02-OW';

/**
 * Version de référence du client, affichée sous le nom de l'entreprise.
 *
 * Le client fait évoluer l'application d'origine et numérote ses versions ;
 * c'est en lisant « Espace pro · V288 » dans l'en-tête qu'il vérifie que la
 * version en ligne porte bien ses dernières reprises. Une seule constante à
 * changer à chaque reprise.
 */
export const VERSION_CLIENT = 'V288';
